<template>
  <b-button
    variant="warning"
    @click="update"
    :disabled="!updatable"
  >
    <b-icon
      icon="arrow90deg-up"
    />
    パスワードを変更
  </b-button>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'settings/passwordChange'
    }
  },

  computed: {
    updatable () {
      return this.$store.getters[`${this.modelName}/updatable`]
    }
  },

  methods: {
    async update () {
      this.$store.dispatch('modal/setUpdate', async () => {
        this.$store.dispatch('loading/show')
        const result = await this.$store.dispatch(`${this.modelName}/update`)
        this.$store.dispatch('loading/hide')

        if (result) {
          this.$store.dispatch('toast/show', {
            content: '変更が完了しました。',
            title: 'パスワードの変更'
          })
        }
      })
    }
  }
}
</script>
